import { render, staticRenderFns } from "./FreshDesk.vue?vue&type=template&id=7f0a8efa&"
import script from "./FreshDesk.vue?vue&type=script&lang=js&"
export * from "./FreshDesk.vue?vue&type=script&lang=js&"
import style0 from "./FreshDesk.vue?vue&type=style&index=0&media=screen%2C%20projection&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports